<template>
    <f-dialog
        v-model       = "value"
        :title        = "'Einstellungen ' + (customer ? customer.name : '')"
        :full-screen  = "true"
        :hide-actions = "true"
        @cancel       = "onClose"
    >
        <template v-slot:content>
            <div>
                <v-tabs
                    v-model      = "tab"
                    class        = "mt-2 folder-tabs ml-0 mr-0 pr-0"
                    active-class = "folder-tab-active primary"
                    height       = "35"
                    light
                    show-arrows
                >
                    <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab
                        class="folder-tab"
                        :key="1"
                    >
                        Standardmails
                    </v-tab>
                    <v-tab
                        class="folder-tab"
                        :key="2"
                    >
                        Signaturen
                    </v-tab>

                    <v-tabs-items v-model="tab">
                        <v-tab-item :key="1">
                            <template-mails :customer="customer ? customer.id : null" ref="tab" />
                        </v-tab-item>

                        <v-tab-item :key="2">
                            <template-signatures ref="tab" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </div>
        </template>
    </f-dialog>
</template>

<script>

import Core               from "@/modules/core/service/Core";
import FDialog            from "@/modules/core/components/utils/FDialog";
import TemplateMails      from "@/modules/msd/templates/components/TemplateMails";
import TemplateSignatures from "@/modules/msd/templates/components/TemplateSignatures";

export default {
    name: "DCustomer",
    components: {
        TemplateSignatures,
        TemplateMails,
        FDialog,
    },

    props: {
        value: {

        },

        customer: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        }
    },

    data: () => ({
        tab: 0,
    }),

    computed: {
        privileged () {
            return Core.role.privileged();
        },
    },

    methods: {
        onClose () {
            this.site = null;
            this.$emit("input", false);
        },
    }
}
</script>

<style scoped>

::v-deep .v-tabs-bar {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: lightgray;
}

</style>